/**
 * This class contains all the information about the Google in-app product details.
 */
export class ProductInAppDetails {
    constructor(price) {
        this.price = price;
    }
}
//# sourceMappingURL=ProductInAppDetails.js.map